import { fakerFR as faker, fakerFR } from '@faker-js/faker';
import type { Company } from '../schema/Company/Company';
import type { CompanyWorkshop } from '../schema/Company/CompanyWorkshop';
import { genSiret } from './testFixtures';

export const genCompany = (data?: Partial<Company>): Company => ({
  siret: genSiret(),
  name: fakerFR.company.name(),
  address: faker.location.streetAddress({ useFullAddress: true }),
  postalCode: faker.location.zipCode(),
  city: null,
  tradeName: null,
  geolocation: null,
  nafCode: null,
  kinds: null,
  ...data
});

export const CompanyFixture = genCompany({
  siret: '11111111111111',
  name: 'Company 1',
  address: '1 rue de la Paix',
  postalCode: '87000'
});

export const SlaughterhouseCompanyFixture1 = genCompany({
  siret: '22222222222222',
  name: 'Slaughterhouse Company',
  address: '2 avenue des Champs',
  postalCode: '69000',
  kinds: ['MEAT_SLAUGHTERHOUSE']
});

export const SlaughterhouseCompanyFixture2 = genCompany({
  siret: '33333333333333',
  name: 'Another Slaughterhouse Company',
  address: '3 boulevard Saint-Michel',
  postalCode: '75000',
  kinds: ['MEAT_SLAUGHTERHOUSE']
});

export const SlaughterhouseWorkshopFixture1: CompanyWorkshop = {
  id: 'bbbbbbbb-0000-4000-8000-000000000001',
  siret: SlaughterhouseCompanyFixture1.siret,
  ateIdentifiant: 'A01',
  ateLb: 'Abattage gros bovins'
};

export const SlaughterhouseWorkshopFixture2: CompanyWorkshop = {
  id: 'bbbbbbbb-0000-4000-8000-000000000002',
  siret: SlaughterhouseCompanyFixture1.siret,
  ateIdentifiant: 'A02',
  ateLb: 'Découpe et désossage'
};
